import { convertTag } from '../utils/helpers'

const ENTER_KEY = 'Enter'

const adjustExpanded = function (accordion: Element, element: Element, expanded: string) {
  element.setAttribute('aria-expanded', expanded)
  accordion.setAttribute('dk-accordion-open', expanded)
}

const isExpanded = function (element: Element) {
  return element.getAttribute('aria-expanded') === 'true'
}

const initialToggleExpanded = function (accordion: Element, toggle: Element) {
  if (toggle.hasAttribute('aria-expanded') && !toggle.hasAttribute('ns-trigger-1') && !toggle.hasAttribute('ns-trigger-2')) return
  adjustExpanded(accordion, toggle, 'false')
}

const closeAccordion = initialToggleExpanded

const openAccordion = function (accordion: Element, toggle: Element, group: Element | null) {
  if (!group) {
    adjustExpanded(accordion, toggle, 'true')
    return
  }

  const openAccordion = group?.parentElement?.querySelector('[dk-accordion-open="true"]')
  const openAccordionToggle = openAccordion?.querySelector('[aria-expanded]')
 
  if (openAccordion) adjustExpanded(openAccordion, openAccordionToggle, 'false')
  else {
    group.parentElement?.querySelectorAll('[dk-accordion]').forEach((acc)=>{
      const tog = acc.querySelector('[aria-expanded]')
      adjustExpanded(acc, tog, 'false')
    })
  }

    adjustExpanded(accordion, toggle, 'true')
}

const addToggleEventListener = function (accordion: HTMLElement, toggle: HTMLElement, group: Element | null) {
  toggle.addEventListener('click', function (_event: MouseEvent) {
    isExpanded(toggle) ? closeAccordion(accordion, toggle) : openAccordion(accordion, toggle, group)
  })
}

const addAccordionEventListener = function (accordion: HTMLElement, toggle: Element, group: Element | null) {
  accordion.addEventListener('keydown', function (event: KeyboardEvent) {
    if (event.key === ENTER_KEY && event.target === toggle) {
      event.preventDefault()
      isExpanded(toggle) ? closeAccordion(accordion, toggle) : openAccordion(accordion, toggle, group)
    }
  })
}



const Accordion = () => {
  Array.from(document.querySelectorAll('[dk-accordion]')).forEach((accordion: Element) => {
    const toggle: Element = convertTag(accordion.children[0], 'button')
    const group: HTMLElement | null = accordion.closest('[dk-accordion-group]')
    initialToggleExpanded(accordion, toggle)
    addToggleEventListener(accordion as HTMLElement, toggle as HTMLElement, group)
    addAccordionEventListener(accordion as HTMLElement, toggle, group)
  })
}

//MARSHES BUTTON HANDLE (ATTRIBUTES-1)
const handleRestoreClickMarsh = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-1]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-1]')
  const locationTrig = document.querySelector('[dk-location-trigger-1]')
  const aboutTrig = document.querySelector('[dk-about-trigger-1]')
  benefitsTrig?.setAttribute('aria-expanded', 'false')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
}

const handleBenefitsClickMarsh = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-1]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-1]')
  const locationTrig = document.querySelector('[dk-location-trigger-1]')
  const aboutTrig = document.querySelector('[dk-about-trigger-1]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const handleAboutClickMarsh = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-1]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-1]')
  const locationTrig = document.querySelector('[dk-location-trigger-1]')
  const aboutTrig = document.querySelector('[dk-about-trigger-1]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'true')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'false')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const benefitsButton1 = document.querySelector('[dk-benefits-open-1]')
const restoreButton1 = document.querySelector('[dk-restore-open-1]')
const aboutButton1 = document.querySelector('[dk-about-open-1]')
const learnMoreButton1 = document.querySelector('[dk-learn-more-open-1]')

restoreButton1?.addEventListener('click', handleRestoreClickMarsh)
benefitsButton1?.addEventListener('click', handleBenefitsClickMarsh)
aboutButton1?.addEventListener('click', handleAboutClickMarsh)
learnMoreButton1?.addEventListener('click', handleAboutClickMarsh)

//MANGROVE BUTTON HANDLE (ATTRIBUTES-2)
const handleRestoreClickMangrove = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-2]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-2]')
  const locationTrig = document.querySelector('[dk-location-trigger-2]')
  const aboutTrig = document.querySelector('[dk-about-trigger-2]')
  benefitsTrig?.setAttribute('aria-expanded', 'false')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
}

const handleBenefitsClickMangrove = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-2]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-2]')
  const locationTrig = document.querySelector('[dk-location-trigger-2]')
  const aboutTrig = document.querySelector('[dk-about-trigger-2]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const handleAboutClickMangrove = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-2]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-2]')
  const locationTrig = document.querySelector('[dk-location-trigger-2]')
  const aboutTrig = document.querySelector('[dk-about-trigger-2]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'true')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'false')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const benefitsButton2 = document.querySelector('[dk-benefits-open-2]')
const restoreButton2 = document.querySelector('[dk-restore-open-2]')
const aboutButton2 = document.querySelector('[dk-about-open-2]')

restoreButton2?.addEventListener('click', handleRestoreClickMangrove)
benefitsButton2?.addEventListener('click', handleBenefitsClickMangrove)
aboutButton2?.addEventListener('click', handleAboutClickMangrove)

//SEAWEED BUTTON HANDLE (ATTRIBUTES-3)
const handleRestoreClickSeaweed = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-3]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-3]')
  const locationTrig = document.querySelector('[dk-location-trigger-3]')
  const aboutTrig = document.querySelector('[dk-about-trigger-3]')
  benefitsTrig?.setAttribute('aria-expanded', 'false')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
}

const handleBenefitsClickSeaweed = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-3]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-3]')
  const locationTrig = document.querySelector('[dk-location-trigger-3]')
  const aboutTrig = document.querySelector('[dk-about-trigger-3]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const handleAboutClickSeaweed = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-3]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-3]')
  const locationTrig = document.querySelector('[dk-location-trigger-3]')
  const aboutTrig = document.querySelector('[dk-about-trigger-3]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'true')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'false')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const benefitsButton3 = document.querySelector('[dk-benefits-open-3]')
const restoreButton3 = document.querySelector('[dk-restore-open-3]')
const aboutButton3 = document.querySelector('[dk-about-open-3]')

restoreButton3?.addEventListener('click', handleRestoreClickSeaweed)
benefitsButton3?.addEventListener('click', handleBenefitsClickSeaweed)
aboutButton3?.addEventListener('click', handleAboutClickSeaweed)

//FISH BUTTON HANDLE (ATTRIBUTES-4)
const handleRestoreClickFish = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-4]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-4]')
  const locationTrig = document.querySelector('[dk-location-trigger-4]')
  const aboutTrig = document.querySelector('[dk-about-trigger-4]')
  benefitsTrig?.setAttribute('aria-expanded', 'false')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
}

const handleBenefitsClickFish = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-4]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-4]')
  const locationTrig = document.querySelector('[dk-location-trigger-4]')
  const aboutTrig = document.querySelector('[dk-about-trigger-4]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const handleAboutClickFish = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-4]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-4]')
  const locationTrig = document.querySelector('[dk-location-trigger-4]')
  const aboutTrig = document.querySelector('[dk-about-trigger-4]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'true')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'false')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const benefitsButton4 = document.querySelector('[dk-benefits-open-4]')
const restoreButton4 = document.querySelector('[dk-restore-open-4]')
const aboutButton4 = document.querySelector('[dk-about-open-4]')
const learnMoreButton4 = document.querySelector('[dk-learn-more-open-4]')

restoreButton4?.addEventListener('click', handleRestoreClickFish)
benefitsButton4?.addEventListener('click', handleBenefitsClickFish)
aboutButton4?.addEventListener('click', handleAboutClickFish)
learnMoreButton4?.addEventListener('click', handleAboutClickFish)

//WHALES BUTTON HANDLE (ATTRIBUTES-5)
const handleRestoreClickWhales = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-5]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-5]')
  const locationTrig = document.querySelector('[dk-location-trigger-5]')
  const aboutTrig = document.querySelector('[dk-about-trigger-5]')
  benefitsTrig?.setAttribute('aria-expanded', 'false')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
}

const handleBenefitsClickWhales = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-5]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-5]')
  const locationTrig = document.querySelector('[dk-location-trigger-5]')
  const aboutTrig = document.querySelector('[dk-about-trigger-5]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'false')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'true')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const handleAboutClickWhales = () => {
  const restoreTrig = document.querySelector('[dk-restore-trigger-5]')
  const benefitsTrig = document.querySelector('[dk-benefits-trigger-5]')
  const locationTrig = document.querySelector('[dk-location-trigger-5]')
  const aboutTrig = document.querySelector('[dk-about-trigger-5]')
  locationTrig?.setAttribute('aria-expanded', 'false')
  aboutTrig?.setAttribute('aria-expanded', 'true')
  restoreTrig?.setAttribute('aria-expanded', 'false')
  benefitsTrig?.setAttribute('aria-expanded', 'false')

  benefitsTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  locationTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
  aboutTrig?.parentElement?.setAttribute('dk-accordion-open', 'true')
  restoreTrig?.parentElement?.setAttribute('dk-accordion-open', 'false')
}

const benefitsButton5 = document.querySelector('[dk-benefits-open-5]')
const restoreButton5 = document.querySelector('[dk-restore-open-5]')
const aboutButton5 = document.querySelector('[dk-about-open-5]')
const learnMoreButton5 = document.querySelector('[dk-learn-more-open-5]')

restoreButton5?.addEventListener('click', handleRestoreClickWhales)
benefitsButton5?.addEventListener('click', handleBenefitsClickWhales)
aboutButton5?.addEventListener('click', handleAboutClickWhales)
learnMoreButton5?.addEventListener('click', handleAboutClickWhales)


//NEW ACC GROUP
const accordionArray = document.querySelectorAll('[dk-accordion-nss]')
const leftTrigger = document.querySelector('[ns-trigger-1]')
const rightTrigger = document.querySelector('[ns-trigger-2]')
const leftAccordion = document.querySelector('[acc1]')
const rightAccordion = document.querySelector('[acc2]')

const handleTrigger1 = () => {
    rightAccordion?.setAttribute('dk-accordion-open', 'false')
    leftAccordion?.setAttribute('dk-accordion-open', 'true')
    leftTrigger?.setAttribute('aria-expanded', 'true')
    rightTrigger?.setAttribute('aria-expanded', 'false')  
}

const handleTrigger2 = () => {
  leftAccordion?.setAttribute('dk-accordion-open', 'false')
  rightAccordion?.setAttribute('dk-accordion-open', 'true')
  rightTrigger?.setAttribute('aria-expanded', 'true')  
  leftTrigger?.setAttribute('aria-expanded', 'false')
  leftTrigger?.setAttribute('style', 'border-bottom-left-radius: 10px;')
  leftAccordion?.setAttribute('style', 'flex: 0;')

}

rightTrigger?.addEventListener('click', handleTrigger2)
leftTrigger?.addEventListener('click', handleTrigger1)


export default Accordion
